module.exports = __webpack_public_path__ + "img/hero-photo-1.ea1fe106.jpg";